import { useEffect, useState } from 'react';
import styles from './loginServer.module.css';
import { LoadingAnimation, OnDeckLogo } from '@odmonorepo/core-components';
import { Col, Row, Card, Stack } from 'react-bootstrap';
import { useRouter } from '@tanstack/react-router';

declare global {
  namespace React.JSX {
    interface IntrinsicElements {
      'login-page': any;
    }
  }
}

export const LoginServer = ({redirect = '/' }) => {
  const [wcLoading, setWcLoading] = useState(true);
  const router = useRouter();
  useEffect(() => {
    const script = document.createElement('script');
    script.src = import.meta.env.VITE_LOGIN_PAGE_JS_SRC!;
    document.body.appendChild(script);
    script.onload = () => setWcLoading(false);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const passwordUrl = router.buildLocation({
    to: '/password',
    search: { redirect }
  });

  const otpUrl = router.buildLocation({
    to: '/login/otp',
    search: { redirect: passwordUrl.pathname + passwordUrl.searchStr }
  })

  return (
    <Row className="my-5">
      <Col xs={12} md={6} className="m-auto" style={{ maxWidth: '600px', width: '100%' }}>
        <h1 className="h2 mb-6 text-center">Sign In</h1>
        <Card className="p-5">
          {wcLoading ? (
            <Stack className="py-5 mb-2">
              <LoadingAnimation className="mx-auto py-8 my-8" />
            </Stack>
          ) : (
            <login-page
              className={styles.container}
              captcha-engine="RECAPTCHA"
              captcha-key={import.meta.env.VITE_LOGIN_SERVER_CAPTCHA_KEY}
              tenant-id={import.meta.env.VITE_LOGIN_SERVER_CLIENT_ID}
              login-server-uri={import.meta.env.VITE_LOGIN_SERVER_URL}
              redirect-uri={import.meta.env.VITE_SPICEROAD_URL + "/v1/users/oauth2redirect?location=" + window.location.href}
              response-mode="form_post"
              login-label="Sign In"
              forgot-password-url={otpUrl.href}
            />
          )}
        </Card>
        <div className="text-center mt-6">
          <a
            href={otpUrl.href}
            title="Forgot Password"
            id="link-reset"
          >
            Forgot your password?
          </a>
        </div>
      </Col>
    </Row>
  );
};

export default LoginServer;
